// Polyfill ES6 features, mainly for IE 11 support
import 'core-js/stable';

import jQuery from 'jquery';
import { Promise } from 'bluebird';

import './js/url-hash-routing-transitions';
import './js/issue-reader-hooks';
import webApp from './js/webApp';

window.AsteikkoWebApp = webApp;

// We expose this jQuery instance for customer-specific customizations
// (i.e. for AsteikkoReaderPlugin clients)
window.$ = window.jQuery = jQuery;

// IE 11 doesn't have window.Promise, and needs a Promise implementation
if ( !window.Promise ) {
  window.Promise = Promise;
}
